import {
  ArrowCounterclockwise,
  FolderSymlink,
  Share,
  Trash,
  Download,
  Folder2Open,
  FolderX,
  FolderPlus,
  Archive,
  Funnel,
  FunnelFill,
  Cart,
  PlusLg,
  Upload,
  ArchiveFill,
  UpcScan,
  PencilSquare,
} from 'react-bootstrap-icons';
import { Api } from './interface';
import { toast } from 'react-toastify';
import NavTabs from './navTabs.js';
import FilterCRUD from './filterCRUD';
import FilterDelete from './filterDelete';
import { Hint } from './constants';
import { DebounceInput } from 'react-debounce-input';
import { useEffect, useState } from 'react';
import { Button, ButtonGroup, Stack } from 'react-bootstrap';
import { bake } from './common';
import { useSearchParams } from 'react-router-dom';
export default function PageHeader(props) {
  const [currentFilterAction, setCurrentFilterAction] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const [loadedFilter, setLoadedFilter] = useState(null);
  const [loadedFilterName, setLoadedFilterName] = useState(null);
  const [hovering, setHovering] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [loadedFilterId, setLoadedFilterId] = useState(null);

  const shareFilter = () => {
    navigator.clipboard.writeText(
      window.location.href + '?sfid=' + loadedFilterId
    );
    toast.success('Link copied');
  };

  useEffect(() => {
    const sfid = searchParams.get('sfid');
    if (sfid) {
      Api({
        sp: 'getUserFilterById',
        json: { id: sfid },
      }).then((response) => {
        setSearchParams('');
        loadFilter(
          JSON.parse(response[0].Filter),
          response[0].FilterName,
          sfid,
          props.currentEntityType,
          true
        );
      });
    }
  }, []);

  const openFilterModal = (action) => {
    props.setCurrentModalRef('FilterCRUD');
    setCurrentFilterAction(action);
  };

  const filterAction = (filter, action) => {
    if (action === 'save') {
      saveFilter(filter.FilterName);
    } else {
      loadFilter(
        JSON.parse(filter.Filter),
        filter.FilterName,
        filter.UserFilter_DBID
      );
    }
  };

  const buildFilterObject = (cols) => {
    return {
      fields: props.columns.filter((x) => x.id !== 'Menu') ?? [],
      filters: bake({ props: props, key: 'filters' }) ?? [],
      order: bake({ props: props, key: 'order' }) ?? 'asc',
      orderBy: bake({ props: props, key: 'orderBy' }) ?? cols[0].id,
      rows: bake({ props: props, key: 'rowsPerPage' })
        ? Number(bake('rowsPerPage'))
        : 15,
      text: bake({ props: props, key: 'searchText' }) ?? '',
    };
  };

  const saveFilter = (name) => {
    const filter = buildFilterObject(props.columns);
    Api({
      sp: 'saveFilter',
      json: {
        level: props.level.length ? props.level : 'Equipment',
        type: props.type,
        name: name,
        filter: filter,
      },
    }).then(() => {
      toast.success('Filter Saved');
      props.setCurrentModalRef(null);
      setLoadedFilter(filter);
      setLoadedFilterName(name);
    });
  };

  const loadFilter = (
    filter = loadedFilter,
    name = loadedFilterName,
    filterId,
    type,
    shared = false
  ) => {
    bake({
      props: props,
      key: 'fields',
      value: filter.fields
        .filter((x) => x.id !== 'Menu')
        .map((x, index) => ({ ...x, sortOrder: index + 1 })),
    });
    bake({ props: props, key: 'filters', value: filter.filters });
    bake({ props: props, key: 'searchText', value: filter.text });
    bake({ props: props, key: 'orderBy', value: filter.orderBy });
    bake({ props: props, key: 'order', value: filter.order });
    bake({ props: props, key: 'rowsPerPage', value: filter.rows });
    toast.success('Filter Loaded');
    props.setCurrentModalRef(null);

    if (!shared) {
      setLoadedFilter(filter);
      setLoadedFilterName(name);
      setLoadedFilterId(filterId);
    }
    props.fetchData(true, type, undefined, undefined, true);
  };

  const deleteFilter = () => {
    Api({
      sp: 'deleteFilter',
      json: {
        level: props.level.length ? props.level : 'Equipment',
        name: loadedFilterName,
      },
    }).then(() => {
      toast.success('Filter Deleted');
      setLoadedFilter(null);
      setLoadedFilterName(null);
      setLoadedFilterId(null);
      props.setCurrentModalRef(null);
    });
  };

  const clearAllFilters = () => {
    setLoadedFilter(null);
    setLoadedFilterName(null);
    setLoadedFilterId(null);
    props.clearAllFilters();
  };

  return (
    <>
      <div className="mt-2 d-flex justify-content-between align-items-center">
        {/* Header Title */}
        {/* If noHeaderContext is true, hide the filter details and/or button groups */}
        {/* Apply css gradient to header title*/}
        {props.noHeaderContext ? (
          <div
            className={
              window.location.href.indexOf('elm.') !== -1
                ? 'gradient-myHomePage w-100'
                : window.location.href.indexOf('elm-qa') !== -1
                  ? 'gradient-myHomePage-qa w-100'
                  : 'gradient-myHomePage-dev w-100'
            }
          >
            <h2 className={'myHomePage-header'}>{props.pageTitle}</h2>
          </div>
        ) : (
          <h2>{props.pageTitle}</h2>
        )}

        {loadedFilter && !props.areFiltersCleared
          ? ' - ' + loadedFilterName
          : null}
        {loadedFilter && !props.areFiltersCleared && !props.noHeaderContext ? (
          <span>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Update Filter"
            >
              <FolderSymlink
                className={'filter-save-icon'}
                size={30}
                onClick={() => {
                  props.saveFilter(props.loadedFilterName);
                }}
              ></FolderSymlink>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Discard Changes"
            >
              <ArrowCounterclockwise
                className={'filter-save-icon'}
                size={30}
                onClick={() => loadFilter()}
              ></ArrowCounterclockwise>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Share Filter"
            >
              <Share
                className={'filter-save-icon'}
                size={30}
                color={'blue'}
                onClick={() => shareFilter()}
              ></Share>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Delete Filter"
            >
              <Trash
                className={'filter-save-icon'}
                size={30}
                color={'red'}
                onClick={() => {
                  props.setCurrentModalRef('FilterDelete');
                  props.setHeaderContextAnchor(null);
                }}
              ></Trash>
            </Hint>
          </span>
        ) : null}

        {props.level === 'Material' && !props.noHeaderContext ? (
          <NavTabs
            navItems={[
              { name: 'INVENTORY', route: '/' + props.type.toLowerCase() },
              {
                name: 'TRANSACTIONS',
                route: '/transactions/' + props.type.toLowerCase(),
              },
            ]}
          />
        ) : null}
      </div>
      <Stack direction="horizontal" gap={3}>
        {/* Search Bar */}
        <DebounceInput
          value={props.searchText}
          className="form-control"
          minLength={0}
          debounceTimeout={700}
          onChange={(event) => props.handleTextChange(event)}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              props.handleTextChange(event);
              props.getSearchResults();
            }
          }}
          placeholder="Search"
        />
        {!props.noHeaderContext ? (
          <>
            {/* Quick Buttons Menu */}
            <ButtonGroup>
              {props.level !== 'EPO' && props.canEdit && !props.archiveMode ? (
                <>
                  {/* Add Entity Button */}
                  <Hint
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    title="Add Entity"
                  >
                    <Button
                      id="add-entity-btn"
                      className="icon-btn"
                      variant="outline-primary"
                      onClick={() => props.setCurrentModalRef('EntityCreate')}
                    >
                      <PlusLg size={24} />
                    </Button>
                  </Hint>

                  <>
                    {/* Bulk Upload Button */}
                    <Hint
                      placement="top"
                      delay={{ show: 250, hide: 400 }}
                      title="Bulk Upload"
                    >
                      <Button
                        className="icon-btn"
                        variant="outline-primary"
                        onClick={() => props.enableBulkUpload()}
                      >
                        <Upload size={24} />
                      </Button>
                    </Hint>

                    {/* Bulk Edit Button */}
                    <Hint
                      placement="top"
                      delay={{ show: 250, hide: 400 }}
                      title="Bulk Edit"
                    >
                      <Button
                        className="icon-btn"
                        variant="outline-primary"
                        onClick={() => props.enableBulkEdit()}
                      >
                        <PencilSquare size={24} />
                      </Button>
                    </Hint>
                  </>
                </>
              ) : null}

              <Hint
                placement="top"
                delay={{ show: 250, hide: 400 }}
                title="Export to Excel"
              >
                <Button
                  className="icon-btn"
                  type="radio"
                  variant="outline-primary"
                  onClick={() => props.setCurrentModalRef('ExportCSV')}
                >
                  <Download className="export" size={20} />
                </Button>
              </Hint>

              <Hint
                placement="top"
                delay={{ show: 250, hide: 400 }}
                title="Save Filter"
              >
                <Button
                  className="icon-btn"
                  variant="outline-primary"
                  onClick={() => openFilterModal('save')}
                >
                  <FolderPlus size={24} />
                </Button>
              </Hint>

              <Hint
                placement="top"
                delay={{ show: 250, hide: 400 }}
                title="Load Filter"
              >
                <Button
                  className="icon-btn"
                  variant="outline-primary"
                  onClick={() => openFilterModal('load')}
                >
                  <Folder2Open size={24} />
                </Button>
              </Hint>

              <Hint
                placement="top"
                delay={{ show: 250, hide: 400 }}
                title="Clear All Filters"
              >
                <Button
                  className="icon-btn"
                  variant="outline-primary"
                  onClick={() => clearAllFilters()}
                >
                  <FolderX size={24} />
                </Button>
              </Hint>

              {props.level === 'Material' && !props.archiveMode ? (
                <Hint
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  title="Group View"
                >
                  <Button
                    className="icon-btn"
                    variant="outline-primary"
                    onClick={() => props.setCurrentModalRef('GroupedView')}
                  >
                    {!props.groupId || props.groupId === -1 ? (
                      <Funnel size={24} />
                    ) : (
                      <FunnelFill size={24} />
                    )}
                  </Button>
                </Hint>
              ) : null}

              {!props.groupId || props.groupId === -1 ? (
                <>
                  <Hint
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    title="Archive View"
                  >
                    <Button
                      className="icon-btn"
                      variant="outline-primary"
                      onClick={() =>
                        props.fetchArchivalView(!props.archiveMode)
                      }
                    >
                      {props.archiveMode ? (
                        <ArchiveFill size={23} />
                      ) : (
                        <Archive size={23} />
                      )}
                    </Button>
                  </Hint>

                  {!props.archiveMode ? (
                    <Hint
                      placement="top"
                      delay={{ show: 250, hide: 400 }}
                      title="Scan items for location confirmation"
                    >
                      <Button
                        className="icon-btn"
                        variant="outline-primary"
                        onClick={() =>
                          props.setCurrentModalRef('EntityLocationScan')
                        }
                      >
                        <UpcScan size={23} />
                      </Button>
                    </Hint>
                  ) : null}
                </>
              ) : null}

              {props.level === 'Material' && props.groupId !== -1 ? (
                <Hint
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  title="View Request Cart"
                  open={hovering}
                >
                  <Button
                    disabled={props.request?.reserved?.length ? false : true}
                    variant="outline-primary"
                    onMouseOver={() => setHovering(true)}
                    onMouseLeave={() => setHovering(false)}
                    onClick={() => {
                      if (props.request.reserved.length) {
                        props.setCurrentModalRef('RequestCreate');
                        props.setCartActive(true);
                      }
                    }}
                  >
                    <Cart size={24} />
                  </Button>
                </Hint>
              ) : null}
            </ButtonGroup>
          </>
        ) : null}
      </Stack>
      {props.currentModal === 'FilterCRUD' ? (
        <FilterCRUD
          close={props.closeModal}
          action={currentFilterAction}
          open={props.currentModal === 'FilterCRUD'}
          crudAction={filterAction}
          level={props.level}
          type={props.type}
        ></FilterCRUD>
      ) : null}
      {props.currentModal === 'FilterDelete' ? (
        <FilterDelete
          open={props.currentModal === 'FilterDelete'}
          close={props.closeModal}
          name={loadedFilterName}
          delete={deleteFilter}
        ></FilterDelete>
      ) : null}
    </>
  );
}
